// Looked up via document.getElementById from shared components, so these must
// live apart from the components that render them (see docs/bundle-analysis.md).
export const CP_DESKTOP_SIDEBAR_ID = 'cp-desktop-sidebar'
export const CP_MOBILE_MENU_ID = 'cp-mobile-menu'
